<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :selection="false"
      :toolbar="toolbar"
      labelWidth="120px"
    ></STable>
  </div>
</template>

<script>
export default {
  name: "batteryAlarm",
  components: {},
  data() {
    return {
      url: "/battery/dcProtocol/page",
      columns: [
        {
          label: "协议名称",
          prop: "name",
        },
        {
          label: "创建人",
          prop: "creatorName",
        },
        {
          label: "创建时间",
          prop: "createTime",
        }
      ],
      // 操作栏
      handles: {
        width: 300,
        btns: [
          {
            label: "详情",
            style: "color:#00CC00",
            permission: "AgreementManagement.pagedetail",
            handle: (resp) => {
              this.$router.push({
                path: "./agreementDetail",
                query: { data: resp },
              });
            },
          },
          {
            label:'修改',
            style: "color:#00CC00",
            permission: "AgreementManagement.pageupdate",
            handle:resp=>{
              this.$router.push({
                path:"./reviseAgreement",
                query:{data:resp},
              })
            }
          },
          {
            label:"删除",
            style:"color:red",
            url:"/battery/dcProtocol/delete",
            method:"delete",
            permission:"AgreementManagement.delete",
            isConfirm: true,
            before:(index,record) => {
            return {
                id:record.id
            };
            },
            handle: () =>{
                this.$refs.tableref.queryTable();
            }
          }
        ],
      },
      query: [
        {
          label: "协议名称",
          prop: "name",
          placeholder: "请输入协议名称",
        }
      ],
      toolbar: [
        {
          label: "新增",
          type: "success",
          permission:"AgreementManagement.pageadd",
          handle: resp => {
            this.$router.push("./addAgreement")
          }
        }
      ],
    };
  },
  computed: {},
  methods: {
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/agreementManagement/agreementManagement.vue